import ReactPDF, { View } from '@react-pdf/renderer';
import React from 'react';
import Dialog from 'src/components/common/Dialog';
import DialogList from 'src/dialogs';
import { Page, Text, Document, StyleSheet } from '@react-pdf/renderer';
import { AnyObject } from 'final-form';
import { useDispatch } from 'react-redux';
import actions from 'src/actions';
// import LeaseClause from 'src/models/LeaseClause';
import MathUtil from 'src/util/MathUtil';
import Acknowledgement from 'src/models/leasing/Acknowledgement';
import SignatureBlock from 'src/models/leasing/SignatureBlock';
import LeaseClauseType from 'src/models/LeaseClauseType';
import LocationModel from 'src/models/leasing/LocationModel';
import moment from 'moment';
import ContractAddendumClause from '../redesign/ContractGenerationModels/ContractAddendumClause';
import Lease from 'src/models/leasehold/Lease';
// tslint:disable: max-line-length

const styles = StyleSheet.create({
    pageMain: {
        backgroundColor: '#FFFFFF',
        paddingTop: '0.54in',
        paddingHorizontal: '0.5in',
        paddingLeft: '0.93in',
        paddingRight: '1.07in',
        fontFamily: 'Times-Roman',
    },
    page: {
        backgroundColor: '#FFFFFF',
        paddingTop: '0.54in',
        paddingHorizontal: '0.5in',
        paddingLeft: '0.93in',
        paddingRight: '1.07in',
        fontFamily: 'Times-Roman',
    },
    pageNumbers: {
        position: 'absolute',
        bottom: 20,
        left: 0,
        right: 0,
        textAlign: 'center',
        fontSize: 10,
        color: '#8e9094',
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1,
    },
    bold: {
        fontFamily: 'Times-Bold',
    },
    fontNormal: {
        fontWeight: 'normal',
        fontSize: '11.5pt',
    },
    mt1: {
        marginTop: 10,
    },
    mt2: {
        marginTop: 20,
    },
    mt3: {
        marginTop: 30,
    },
    mt4: {
        marginTop: 40,
    },
    mb1: {
        marginBottom: 10,
    },
    mb2: {
        marginBottom: 20,
    },
    mr1: {
        marginRight: 5,
    },
    mr2: {
        marginRight: 20,
    },
    ml1: {
        marginLeft: 5,
    },
    ml2: {
        marginLeft: 20,
    },
    center: {
        textAlign: 'center',
    },
    text: {
        textAlign: 'justify',
    },

    underlined: {
        textDecoration: 'underline',
    },
    mailingInfo: {
        fontSize: 10,
        fontFamily: 'Times-Roman',
    },
    exhibitHeading: {
        textAlign: 'center',
        fontSize: 12,
        fontWeight: 'bold',
    },
    acknowledgementHeading: {
        textAlign: 'center',
        fontSize: '13pt',
    },
    leaseHeading: {
        textAlign: 'center',
        fontSize: 20,
        fontFamily: 'Times-Bold',
    },
    singleLine: {
        borderTop: '1px solid black',
    },
    doubleLines: {
        borderTop: '1px solid black',
        borderBottom: '1px solid black',
    },
    lineHeight: {
        lineHeight: 1.25,
    },
    h2: {
        fontSize: 12,
    },
    h3: {
        fontSize: '12pt',
    },
    lessorLabel: {
        width: '75px',
        fontSize: 9,
        textAlign: 'right',
        marginRight: '4',
        fontWeight: 'bold',
    },
    lessorData: {
        maxWidth: '20%',
        fontSize: 9,
    },
    footerText: {
        color: 'grey',
        fontSize: 9,
    },
    ownershipColumn: {
        width: '14%',
        fontSize: 9,
        textAlign: 'right',
    },
    bonusColumn: {
        width: '14%',
        fontSize: 9,
        textAlign: 'right',
        paddingRight: 15,
    },
    dudleyInfo: {
        position: 'absolute',
        bottom: '50px',
        left: '70px',
    },
    sbTitle: {
        textAlign: 'center',
        marginBottom: 10,
    },
});

interface IAethonMemoProps {
    hideDialog?: () => void;
    // TODO: Update IContract to include these missing fields.
    leaseData?: Lease;
    leaseClauses?: ContractAddendumClause[];
    leaseClauseTypes?: LeaseClauseType[];
    location?: LocationModel;
}

const AethonMemo = (props: IAethonMemoProps) => {
    const dispatch = useDispatch();
    // const firstIncludedTract = props?.leaseData?.tracts?.find((tract: AnyObject) => tract.includeTract === true);
    const totalGrossAcres = props?.leaseData?.tracts?.reduce((acc: number, tract: AnyObject) => {
        let acreage = acc;
        if (tract.includeTract === true) {
            let tempGrossAcres = parseFloat(tract.grossAcres) || 0;
            acreage += tempGrossAcres;
        }

        return acreage;
    }, 0);

    const leaseDescription = () => {
        const legalDescription: string = !!props?.leaseData ? props?.leaseData?.legalDescription : '';

        if (!legalDescription) {
            return <Text style={{ fontSize: 9 }}>No Legal Description Available</Text>;
        }

        if (legalDescription.length >= 1000) {
            return (
                <Text style={{ fontSize: '10pt', marginTop: '10px', textAlign: 'center' }}>
                    "SEE ATTACHED EXHIBIT "A" FOR LEGAL DESCRIPTION"
                </Text>
            );
        } else {
            return (
                <>
                    <Text style={[styles.bold]}>{legalDescription}</Text>
                </>
            );
        }
    };

    const termValDisplay = (mode: string): string => {
        if (mode === 'normal') {
            let primaryTerm: number = !!props?.leaseData ? parseInt(props?.leaseData?.leasehold?.primaryTerm + '', 10) : undefined;
            let primaryTermUnits: string = !!props?.leaseData ? props?.leaseData?.leasehold?.primaryTermUnits : undefined;

            if (!primaryTerm && !primaryTermUnits) {
                return 'Zero (0) Years';
            }

            let primaryTermString = MathUtil.numberToEnglish(primaryTerm, ' ');

            return `${primaryTermString.charAt(2).toUpperCase() + primaryTermString.slice(3)} (${primaryTerm}) ${primaryTermUnits.charAt(0).toUpperCase() + primaryTermUnits.slice(1)
                }`;
        }

        if (mode === 'option') {
            let optionTerm: number = !!props?.leaseData ? parseInt(props?.leaseData?.leasehold?.optionTerm + '', 10) : undefined;
            let optionTermUnits: string = !!props?.leaseData ? props?.leaseData?.leasehold?.optionTermUnits : undefined;
            if (!optionTerm && !optionTermUnits) {
                return 'Zero (0) Years';
            }

            let optionTermString = MathUtil.numberToEnglish(optionTerm, ' ');

            return `${optionTermString.charAt(2).toUpperCase() + optionTermString.slice(3)} (${optionTerm}) ${optionTermUnits.charAt(0).toUpperCase() + optionTermUnits.slice(1)
                }`;
        }

        return '';
    };

    // const optionToExtend = () => {
    //     if (!!props?.leaseData?.leasehold?.optionExercised) {
    //         return `, with an option to extend for an additional ${termValDisplay('option')}`;
    //     } else {
    //         return '';
    //     }
    // };

    const lesseeAddress = () => {
        return !!props?.leaseData
            ? `${props?.leaseData?.lesseeAddressLine1}, ${props?.leaseData?.lesseeCity}, ${props?.leaseData?.lesseeState} ${props?.leaseData?.lesseeZipCode}`
            : '';
    };

    const displaySignatureBlocks = () => {
        return !!props?.leaseData
            ? props?.leaseData?.acknowledgements?.map((la: Acknowledgement) => {
                return (
                    la.signatureBlocks.length > 0 &&
                    la.signatureBlocks.map((sb: SignatureBlock, index: number) => {
                        return (
                            <View key={index} wrap={false} style={styles.mt1}>
                                {!!sb.title && sb?.title.length > 0 && (
                                    <Text style={[styles.fontNormal, styles.mt1, styles.text, styles.bold]}>{sb?.title}</Text>
                                )}
                                {/* <Text style={[styles.fontNormal, styles.mt1, styles.text]}>Lessor:</Text> */}
                                <Text style={[styles.fontNormal, styles.mt4, styles.text, styles.bold]}>____________________________________</Text>
                                <Text style={[styles.fontNormal, styles.text]}>{sb.ownerName}</Text>
                            </View>
                        );
                    })
                );
            })
            : [];
    };

    const displayAcknowledgements = () => {
        return !!props?.leaseData
            ? props?.leaseData?.acknowledgements?.map((la: Acknowledgement, index: number) => {
                return (
                    <View key={index} wrap={false} style={styles.mt2}>
                        <Text style={[styles.fontNormal, styles.mt2]}>{la.text}</Text>
                    </View>
                );
            })
            : [];
    };

    // const additionalProvisions = () => {
    //     let additionalProvisionNumber: number = 0;
    //     let renderClauses: ContractAddendumClause[] = [];
    //     let leaseClauses: ContractAddendumClause[] = !!props?.leaseData && props?.leaseData?.contractClauses;

    //     leaseClauses?.forEach((llc: AnyObject, index: number) => {
    //         let clause: ContractAddendumClause = !!props?.leaseClauses
    //             ? props?.leaseClauses.find((lc) => lc.id === llc.contractAddendumClauseId)
    //             : undefined;

    //         if (!!clause) {
    //             renderClauses.push(clause);
    //         }
    //     });

    //     return renderClauses?.map((rc: ContractAddendumClause, index: number) => {
    //         additionalProvisionNumber++;
    //         return (
    //             <Text key={index} style={[styles.fontNormal, styles.mt2, styles.text]}>
    //                 {additionalProvisionNumber}) {`${rc.leaseClauseType}: ${rc.clauseText}`}
    //             </Text>
    //         );
    //     });
    // };

    // const adhocProvisions = () => {
    //     let additionalProvisionNumber: number = 0;

    //     return (
    //         !!props?.leaseData &&
    //         props?.leaseData?.adHocClauses?.map((lc: LeaseClause, index: number) => {
    //             let type: string = !!props?.leaseClauseTypes ? props?.leaseClauseTypes?.find((lct) => lct.id === lc.leaseClauseTypeId)?.name : '';

    //             additionalProvisionNumber++;
    //             return (
    //                 <Text key={index} style={[styles.fontNormal, styles.mt2, styles.text]}>
    //                     {additionalProvisionNumber + ')'} {`${type}: ${lc.clauseText}`}
    //                 </Text>
    //             );
    //         })
    //     );
    // };

    const renderAcknowledgementAndSignaturePage = () => {
        return !props?.leaseData ? (
            <></>
        ) : props?.leaseData?.acknowledgements?.length > 0 ? (
            <View>
                <Text style={[styles.fontNormal, styles.mt3, styles.mb1, styles.h2, styles.bold, styles.text]}>
                    IN WITNESS WHEREOF, the parties hereto have caused this Memorandum of Oil and Gas Lease to be effective on the date of first above
                    written.
                </Text>
                <View
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                    }}
                >
                    {displaySignatureBlocks()}
                </View>

                <Text style={[styles.acknowledgementHeading, styles.mt4, styles.bold]}>(ACKNOWLEDGMENT)</Text>
                {displayAcknowledgements()}
            </View>
        ) : (
            <></>
            );
    };
    
    const legalToExhibit = () => {
        return !props?.leaseData ? (
            <></>
            ) : props?.leaseData?.legalDescription.length > 1000 ? (
                <View break={true}>
                <Text style={[styles.exhibitHeading, styles.bold]}>Exhibit "A"</Text>
                <Text style={[styles.fontNormal, styles.mt1, styles.text]}>Attached to and made part of that certain Memorandum of Paid Up Oil and Gas Lease dated{' '} 
                <Text style={[styles.bold]}>{moment(props?.leaseData?.effectiveDate).format('MMMM DD, YYYY')}</Text>, 
                    by and between{' '} <Text style={[styles.bold, styles.mt1, styles.text]}>{props?.leaseData?.ownersOnDocument}</Text>
                    , as Lessor, and{' '} <Text style={[styles.bold, styles.mt1, styles.text]}>{props?.leaseData?.lesseeName}</Text>, as Lessee.
                </Text>
                <Text style={[styles.mt2, { fontSize: '11.5pt' }, styles.bold]}>LEGAL DESCRIPTION:</Text>
                <Text style={[styles.fontNormal, styles.mt1, styles.text]}>{props?.leaseData?.legalDescription}</Text>
            </View>
        ) : (
            <></>
            );
        };

    const afterRecording = () => {
        return (
            <View style={[styles.dudleyInfo, styles.fontNormal]} fixed={true}>
                <View>
                    <Text style={[styles.bold, styles.h3]}>After Recording, please return to:</Text>
                    <Text style={{ fontSize: 10 }}>NewPenn Exploration, LLC</Text>
                    <Text style={{ fontSize: 10 }}>817 Avenue A</Text>
                    <Text style={{ fontSize: 10 }}>
                        Katy, Texas 77493 {'      '} DLC LPR#{props?.leaseData?.leaseNumber}
                    </Text>
                </View>
            </View>
        );
    };
    
    // const displayExhibits = () => {
        //     return !props?.leaseData ? (
    //         <></>
    //     ) : props?.leaseData?.adHocClauses.length > 0 ? (
    //         <Page size="LEGAL" style={styles.page}>
    //             <Text style={styles.exhibitHeading}>Exhibit {props?.leaseData?.legalDescription.length > 1000 ? 'B' : 'A'}</Text>
    //             <Text style={[styles.fontNormal, styles.mt3, styles.h2]}>Additional Provisions</Text>
    //             {adhocProvisions()}
    //             {additionalProvisions()}
    //             <Text style={styles.pageNumbers} render={({ pageNumber }) => `${pageNumber}`} fixed={true} />
    //         </Page>
    //     ) : (
    //         <></>
    //     );
    // };

    const displayCounties = () => {
        let counties: Array<string> | undefined = !!props?.location && props?.location?.counties?.filter((c) => !!c);
        let stringCounties: string = '';

        if (!!counties && counties.length > 1) {
            for (let i = 0; i < counties.length; i++) {
                if (!!counties[i] && i !== counties.length - 1) {
                    stringCounties += counties[i] + ', ';
                }
                if (!!counties[i] && i === counties.length - 1) {
                    stringCounties += 'and ' + counties[i] + ' Counties';
                }
            }
            return stringCounties;
        } else if (!!counties && counties.length === 1) {
            return `${counties[0]} County`;
        } else {
            return '';
        }
    };

    return (
        <Dialog title="MEMO" dialogName={DialogList.MEMO_VIEWER} onCloseDialog={() => dispatch(actions.layout.hideDialog())}>
            <ReactPDF.PDFViewer style={{ height: '85vh', width: '70vw' }}>
                <Document>
                    <Page size="LEGAL" style={styles.pageMain}>
                        <View>
                            <View>
                                <Text style={[styles.bold, styles.h3, styles.mt2, { fontSize: '12pt' }]}>
                                    Note of Confidentiality Rights: If you are a natural person, you may remove or strike any of the following
                                    information from this instrument before it is filed in the public records: Your social security number or your
                                    driver's license number.
                                </Text>
                            </View>

                            <View style={{ marginTop: '15px' }}>
                                <Text
                                    style={{
                                        fontSize: '12pt',
                                        textDecorationStyle: 'solid',
                                        textAlign: 'center',
                                        fontFamily: 'Times-Bold',
                                    }}
                                >
                                    MEMORANDUM OF PAID UP OIL AND GAS LEASE
                                </Text>
                            </View>

                            <View style={[{ marginTop: '15px' }, styles.singleLine]} />

                            {/* <View
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'flex-start',
                                    marginTop: '10px',
                                }}
                            >
                                <View>
                                    <Text style={{ fontSize: 9, fontFamily: 'Times-Bold' }}>
                                        STATE OF {!!props?.location ? props?.location?.state?.toUpperCase() : '______'}
                                    </Text>
                                    <Text style={{ fontSize: 9, marginTop: '10px', fontFamily: 'Times-Bold' }}>
                                        COUNTY OF {!!props?.location ? props?.location?.counties[0]?.toUpperCase() : '___________'}
                                    </Text>
                                </View>
                                <View style={{ marginLeft: '30px' }}>
                                    <Text style={{ fontSize: 9 }}>§</Text>
                                    <Text style={{ fontSize: 9 }}>§</Text>
                                    <Text style={{ fontSize: 9 }}>§</Text>
                                </View>
                            </View> */}
                        </View>

                        <View style={{ marginTop: '15px' }}>
                            <Text style={[styles.fontNormal, styles.lineHeight]}>
                                THIS MEMORANDUM of Oil and Gas Lease is made by and between{' '}
                                <Text style={[styles.bold]}>{props?.leaseData?.ownersOnDocument}</Text>, whose address is{' '}
                                <Text style={[styles.bold]}>{props?.leaseData?.ownersAddressOnDocument}</Text> hereinafter called "Lessor", and{' '}
                                <Text style={[styles.bold]}>{props?.leaseData?.lesseeName}</Text>, whose address is{' '}
                                <Text style={[styles.bold]}>{lesseeAddress()}</Text>, hereinafter called "Lessee".
                            </Text>
                        </View>

                        <View style={{ marginTop: '15px' }}>
                            <Text style={[styles.fontNormal, styles.lineHeight]}>
                                That Lessor, for and in consideration of Ten and No/100 dollars and other good and valuable consideration paid by
                                Lessee, the receipt and sufficiency of which is hereby acknowledged, has executed that certain Oil and Gas Lease made
                                and entered on <Text style={[styles.bold]}>{moment(props?.leaseData?.effectiveDate).format('MMMM DD, YYYY')}</Text>,
                                covering that certain <Text style={[styles.bold]}>{totalGrossAcres.toFixed(4) || 'N/A'}</Text> acres of land, 
                                more or less, in <Text style={[styles.bold]}>{displayCounties()},{' '} {!!props?.location ? `${props?.location?.state} ` : ''}</Text> 
                                {'(the "Lease")'}, and said land being further described as follows:
                            </Text>
                        </View>

                        <View style={[styles.fontNormal, { marginBottom: '10px', marginTop: '10px' }]}>{leaseDescription()}</View>

                        <View>
                            <Text style={[{ marginTop: '10px' }, styles.lineHeight, styles.fontNormal, styles.text]}>
                                The term of said Lease is for a period of {termValDisplay('normal')}{' '}
                                {!!props?.leaseData && !!props?.leaseData?.leasehold?.renewalOption
                                    ? `from the effective date, with an option to extend for an additional ${termValDisplay('option')}`
                                    : ''}
                                , and so long thereafter as oil and/or gas is being produced in paying quantities from the Leased Premises, or so long
                                thereafter as operations for the production of oil and/or gas are being conducted in accordance with the terms and
                                conditions of said Paid Up Oil and Gas lease referenced herein.
                            </Text>
                        </View>

                        <View style={{ marginTop: '10px' }}>
                            <Text style={[styles.fontNormal, styles.lineHeight, styles.text]}>
                                Reference is hereby made to executed copies of said Oil and Gas Lease in possession of Lessor and Lessee,
                                respectively, for all of the provisions thereof, and by this reference same are incorporated herein and made a part
                                hereof in all respects as though fully set forth herein.
                            </Text>
                        </View>

                        <View style={{ marginTop: '10px' }}>
                            <Text style={[styles.fontNormal, styles.lineHeight, styles.text]}>
                                The Oil and Gas Lease between Lessor and Lessee also contains a preferential right to purchase in favor of Lessee
                                which affords Lessee a preferential right to acquire mineral or royalty interests owned by Lessor, or its successors
                                and assigns.
                            </Text>
                        </View>

                        <Text
                            style={
                                props?.leaseData?.legalDescription?.length >= 500
                                    ? { fontSize: 10, marginTop: '30px', textAlign: 'center' }
                                    : { fontSize: 10, marginTop: '150px', textAlign: 'center' }
                            }
                        >
                            (SIGNATURES ON THE FOLLOWING PAGE.)
                        </Text>
                        
                        <Text
                            style={
                                props?.leaseData?.legalDescription?.length >= 500
                                    ? { fontSize: 10, marginTop: '30px', textAlign: 'center' }
                                    : { fontSize: 10, marginTop: '150px', textAlign: 'center' }
                            }
                        >
                                THE REST OF THIS PAGE IS INTENTIONALLY LEFT BLANK.
                        </Text>

                        {/* <View style={[styles.dudleyInfo, styles.fontNormal]} fixed={true}>
                            <View>
                                <Text style={[styles.bold, styles.h3]}>After Recording, please return to:</Text>
                                <Text style={{ fontSize: 10 }}>NewPenn Exploration, LLC</Text>
                                <Text style={{ fontSize: 10 }}>817 Avenue A</Text>
                                <Text style={{ fontSize: 10 }}>
                                    Katy, Texas 77493 {'      '} DLC LPR#{props?.leaseData?.leaseNumber}
                                </Text>
                            </View>
                        </View> */}

                        <Text style={styles.pageNumbers} render={({ pageNumber }) => `${pageNumber}`} fixed={true} />
                    </Page>

                    {/* Functions to render pages based on if there are items to render or other logic */}
                    <Page size="LEGAL" style={styles.page} break={true}>
                        {renderAcknowledgementAndSignaturePage()}
                        {legalToExhibit()}
                        {afterRecording()}
                        {/* {displayExhibits()} */}
                        <Text style={styles.pageNumbers} render={({ pageNumber }) => `${pageNumber}`} fixed={true} />
                    </Page>
                </Document>
            </ReactPDF.PDFViewer>
        </Dialog>
    );
};

export default AethonMemo;



// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/MemoTemplates/AethonMemo.tsx